export default __webpack_public_path__ + "static/media/white_A1.593bde59.svg";